const INBOUND = new Set(['inbound', 'incoming', 'received', 'in']);
const OUTBOUND = new Set(['outbound', 'outgoing', 'sent', 'out']);
const KNOWN_STATUS = new Set([
  'sending',
  'sent',
  'delivered',
  'read',
  'failed',
]);

export function normalizeDirection(msg) {
  const raw = String(
    msg?.direction || msg?.message_direction || '',
  ).toLowerCase();
  if (INBOUND.has(raw)) return 'inbound';
  if (OUTBOUND.has(raw)) return 'outbound';
  const sender = String(msg?.sender_type || msg?.sender || '').toLowerCase();
  if (sender === 'client' || sender === 'customer' || sender === 'user') {
    return 'inbound';
  }
  if (
    msg?.is_from_me === true ||
    msg?.from_me === true ||
    msg?.is_outbound === true ||
    sender === 'agent' ||
    sender === 'business' ||
    sender === 'system'
  ) {
    return 'outbound';
  }
  if (msg?.sender_type) return 'outbound';
  return 'outbound';
}

export function normalizeStatus(msg, direction) {
  if (direction !== 'outbound') return null;
  const status = String(msg?.status || '').toLowerCase();
  if (KNOWN_STATUS.has(status)) return status;
  if (msg?.is_read === true) return 'read';
  return null;
}
